import { styled, Typography } from '@mui/material';

export const ContentW = styled('div')`
  width: 100%;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(20px);
  border-radius: 15px;
  padding: 24px 16px;
  position: relative;

  @media (max-width: 1023px) {
    padding: 0px 16px 16px;
  }
`;

export const Title = styled(Typography)`
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  text-transform: none;

  @media (max-width: 1023px) {
    display: none;
  }
`;

export const HeaderW = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
`;

export const ActionsW = styled('div')`
  position: absolute;
  right: 12px;
  top: 12px;
`;
